import './styles/main.scss';

import './scripts/swipers.js';
import './scripts/up.js';
import './scripts/filter-brands.js';
import './scripts/filter-announcements.js';
import './scripts/navigation.js';
import './scripts/opening-hours.js';
import './scripts/brochures.js';